import dexie, { Dexie } from 'dexie'

export class LogItem {
    constructor() {
        this.localTime = new Date();
    }
    localTime: Date
    category: string;
    eventName: string;
    eventIdentifier: string;
    eventData?: { [key: string]: string }
}

export class LogEntry extends LogItem{

    constructor(unitId: string, session: number, fingerprint: string, item: LogItem) {
        super();

        this.unitId = unitId;
        this.session = session;
        this.fingerPrint = fingerprint;
        this.category = item.category;
        this.eventName = item.eventName;
        this.eventIdentifier = item.eventIdentifier;
        this.eventData = item.eventData;
    }

    id?: number;
    unitId: string;
    session: number;
    fingerPrint: string;    
}


export class AppDatabase extends dexie{
    logQueue: dexie.Table<LogEntry, number>;
    static dbName = "AppDatabase";
    static currentVersion = 2;

    constructor() {
        super(AppDatabase.dbName);
        var that = this;
    }

    async bootstrap(): Promise<void> {
        var that = this;
        

        if (this.verno < AppDatabase.currentVersion && this.verno > 0) {
            this.delete();
        }

        this.createDb();
        
    }


    createDb() {
        console.log("Creating DB")
        this.version(AppDatabase.currentVersion).stores({
            logQueue: "++id, unitId, session, fingerPrint, category, eventName, eventData"
        })
    }
}


// WEBPACK FOOTER //
// ./ClientApp/Tracking/AppDatabase.ts